var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.707 16.293L13.7419 12.3274C14.5291 11.2522 15 9.93158 15 8.5C15 4.91602 12.084 2 8.5 2C4.91602 2 2 4.91602 2 8.5C2 12.084 4.91602 15 8.5 15C9.93182 15 11.2526 14.529 12.3279 13.7415L16.293 17.707C16.4883 17.9023 16.7441 18 17 18C17.2559 18 17.5117 17.9023 17.707 17.707C18.0977 17.3164 18.0977 16.6836 17.707 16.293ZM4 8.5C4 6.01855 6.01855 4 8.5 4C10.9814 4 13 6.01855 13 8.5C13 10.9814 10.9814 13 8.5 13C6.01855 13 4 10.9814 4 8.5Z",
  fill: "#302FA0"
})));
export { SvgSearch as ReactComponent };
export default __webpack_public_path__ + "assets/icons/search.ff76e9.svg";